import React from "react";

import Modal from "react-responsive-modal";
// import APPROVE from "../../assets/Accepted.svg";

import AcceptanceGraphic from "../../assets/Acceptance-Graphic.png";

const MetadataBulkDownloadSuccessPopup = ({ closePopup, show, totalDocs }) => (
  <Modal open={show} onClose={closePopup} closeOnOverlayClick center>
    <div
      className="quotationtopbar-container"
      data-test="quotationtopbar-container">
      <div className="docstatus-accptancereject-image">
        <div className="docstatus-confirm-text metadata-bulk-download-text-container">
          {/* <div className="doc-confirm-seal">
            <img
                  src={APPROVE}
                  alt="Approve badge"
                  className="document-sent-confirmation-image"
                />
          </div> */}
          <div className="docstatus-confirm-title">Awesome!</div>
          <div className="docstatus-accept-subtitle">
            Your CSV sheet containing the metadata of {totalDocs} documents has
            downloaded.
          </div>
          <div className="acceptance-docstatus-confirm-footer">
            <span aria-label="bulb" role="img">
              &#128161;
            </span>{" "}
            Use Metalens to extract metadata like this from your documents.
          </div>
        </div>

        <img
          src={AcceptanceGraphic}
          alt="Revv"
          className="document-sent-confirmation-image"
        />
      </div>
    </div>
  </Modal>
);

export default MetadataBulkDownloadSuccessPopup;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/MetadataBulkDownloadSuccessPopup.js